import type { SagaIterator } from 'redux-saga';
import { getCurrentFolderId, getGallectionById, getGrusername } from '../selectors';
import { call, put, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { PapiGallection, PapiRequestDaSharedGallectionFoldersUpdate } from '@wix/da-papi-types';
import { getGallectionType } from '../helpers';
import { requestNapi } from '@wix/da-http-client';
import { normalizeGallection } from '../../redux/normalizr/helpers';
import { putEntities } from '../../redux/entities/actions';
import { dollarsToPoints } from '../../utils/points';

function* convertGalleryHandler(): SagaIterator {
  const currentFolderId: ReturnType<typeof getCurrentFolderId> = yield select(getCurrentFolderId);

  const gallection: ReturnType<typeof getGallectionById> = yield select(
    getGallectionById,
    currentFolderId
  );

  const username: ReturnType<typeof getGrusername> = yield select(getGrusername);

  if (!gallection) {
    return;
  }

  const defaultPriceInDollars = 10;

  const params: PapiRequestDaSharedGallectionFoldersUpdate = {
    username,
    type: getGallectionType(gallection) ?? 'gallery',
    folderid: gallection.folderId,
    name: gallection.name,
    premium_type: 'paid',
    cover_deviationid:
      gallection.type === 'stash' ? undefined : get(gallection, 'thumb.deviationId'),
    points_price: dollarsToPoints(defaultPriceInDollars),
  };

  if (gallection.richDescription) {
    params.editorRaw = gallection.richDescription.html.markup;
  }

  const result = yield call(
    requestNapi,
    {
      method: 'post',
      url: 'gallection/folders/update',
      data: params,
    },
    undefined
  );

  // new gallery converted to premium, reload page
  if (result) {
    const updatedGallection: PapiGallection = {
      ...gallection,
      premiumFolderData: {
        pointsPrice: params.points_price,
        dollarPrice: defaultPriceInDollars,
        numSubscribers: 0,
        type: params.premium_type as string,
        hasAccess: true,
      },
    };

    const entities = normalizeGallection(updatedGallection);
    yield put(putEntities({ entities }));
  }
}

export default convertGalleryHandler;
